import { TextInput } from "app/components/FormInputs/FormInputs";
import { SessionHelper } from "app/helpers/sessionHelper";
import debounce from "lodash/debounce";
import React, { useEffect, useState } from "react";
import { defineMessages } from "react-intl";
import { connect } from "react-redux";
import SearchList from "./components/SearchList/SearchList";

type Props = {
  resetCompetitions: (...args: Array<any>) => any;
  className?: any;
  setSearchList: (...args: Array<any>) => any;
  resetSearchList: (...args: Array<any>) => any;
  total: number;
  query: string;
  stopCompetitionsPolling: (...args: Array<any>) => any;
  selectLeagues: (...args: Array<any>) => any;
};

const Search: React.FC<Props> = props => {
  const [showSearchList, setShowSearchList] = useState(false);

  const fetchSearchList = (query: string) => {
    if (query.length >= 3) {
      props.setSearchList(query);
    } else if (props.total > 0) {
      props.resetSearchList();
    }
  };

  const onMouseLeave = () => {
    setShowSearchList(false);
  };
  const debouncedFetchSearchList = debounce(fetchSearchList, 500);
  const debounceOnMouseLeave = debounce(onMouseLeave, 300);

  useEffect(() => {
    if (props.query.length > 0) {
      props.resetSearchList();
    }
  }, []);

  const showSearchListHandler = () => {
    setShowSearchList(true);
  };

  const updateQuery = (id: string, value: string) => {
    const query = value;
    debouncedFetchSearchList(query);
  };

  const onInputChange = (id: string, value: string) => {
    updateQuery(id, value);

    if (!showSearchList) {
      setShowSearchList(true);
    }
  };

  const I18n = defineMessages({
    search: {
      id: "search-search",
    },
  });

  return (
    <div onMouseLeave={debounceOnMouseLeave} onClick={showSearchListHandler}>
      <TextInput
        type="search"
        id="search-events"
        onChange={onInputChange}
        placeholder={I18n.search}
        className="search-events"
        autoComplete="off"
      />
      {!SessionHelper.isAsianRouteAndSessionView() && showSearchList && (
        <SearchList fetchSearchList={fetchSearchList} />
      )}
      {SessionHelper.isAsianRouteAndSessionView() && showSearchList && (
        <SearchList
          fetchSearchList={fetchSearchList}
          stopCompetitionsPolling={props.stopCompetitionsPolling.bind(this)}
          selectLeagues={props.selectLeagues.bind(this)}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  query: state.searchListModel.query,
  total: state.searchListModel.total,
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    resetCompetitions: () => dispatch.competitionListModel.resetCompetition(),
    setSearchList: name => dispatch.searchListModel.setSearchList(name),
    resetSearchList: name => dispatch.searchListModel.resetSearchList(),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
